/**
 * SP時のページネーション表示を圧縮する
 * 表示: < 1 … [prev] [current] [next] … last >
 */
function compactPagination() {
	const SP_BREAKPOINT = 600;
	const isSP = window.innerWidth <= SP_BREAKPOINT;

	document.querySelectorAll('.wp-block-query-pagination-numbers').forEach(function (nums) {
		nums.querySelectorAll('.page-numbers.js-injected').forEach(function (el) { el.remove(); });

		const items = Array.from(nums.querySelectorAll('.page-numbers:not(.dots)'));
		if (items.length === 0) return;

		nums.querySelectorAll('.page-numbers.dots').forEach(function (el) { el.style.display = 'none'; });

		if (!isSP) {
			items.forEach(function (item) { item.style.display = ''; });
			nums.querySelectorAll('.page-numbers.dots').forEach(function (el) { el.style.display = ''; });
			return;
		}

		const current = nums.querySelector('.page-numbers.current');
		if (!current) {
			items.forEach(function (item) { item.style.display = ''; });
			return;
		}

		const currentNum = parseInt(current.textContent.trim(), 10);
		const firstItem  = items[0];
		const lastItem   = items[items.length - 1];
		const firstNum   = parseInt(firstItem.textContent.trim(), 10);
		const lastNum    = parseInt(lastItem.textContent.trim(), 10);

		const visibleNums = new Set([
			firstNum,
			currentNum - 1,
			currentNum,
			currentNum + 1,
			lastNum,
		]);

		items.forEach(function (item) {
			const n = parseInt(item.textContent.trim(), 10);
			item.style.display = visibleNums.has(n) ? '' : 'none';
		});

		const makeDotsEl = function () {
			const el = document.createElement('span');
			el.className = 'page-numbers dots js-injected';
			el.textContent = '…';
			return el;
		};

		const visibleItems = items.filter(function (item) {
			return item.style.display !== 'none';
		});

		for (let i = 0; i < visibleItems.length - 1; i++) {
			const a = parseInt(visibleItems[i].textContent.trim(), 10);
			const b = parseInt(visibleItems[i + 1].textContent.trim(), 10);
			if (b - a > 1) {
				nums.insertBefore(makeDotsEl(), visibleItems[i + 1]);
			}
		}
	});
}

document.addEventListener('DOMContentLoaded', compactPagination);
window.addEventListener('resize', compactPagination);
